module.exports = __webpack_public_path__ + "ubuntu-light-webfont.92a671f9023183698acd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-light-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-light-webfont.woff2
// module chunks = styles